import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import IconCollection from '../../IconCollection/IconCollection';
import toast from 'react-hot-toast';
import { resetJumpBallClock } from '../../redux/actions/JumpBallClockService';
import { useDispatch } from 'react-redux';
import {  sendTimerData } from "../../redux/actions/playerAction"
const CustomDropdownControlPage = ({ options, setSelectedValue, selectedValue, showConfirmation, setShowConfirmation, selectedOption, setSelectedOption, onChange, onChangeReset, customStyle, customStyleDropdownList, liCustomStyle, defaultValue, dropdownContainer, shotClockValue, possessionArrowTeamOne, possessionArrowTeamTwo, isRunning, minutes, seconds, event_id, event_group_id, event_team_a_id, event_team_b_id }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setSelectedValue(defaultValue || (options?.[0]?.value || null));
  }, []);

  const dropdownRef = useRef(null);
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (value) => {
    const currentIndex = options.findIndex(option => option.value === selectedValue);
    const nextIndex = (currentIndex + 1) % options.length; // Calculate the index of the next option, wrapping around if necessary
    const nextValue = options[nextIndex].value;

    const isNextOption = value === nextValue && value !== selectedValue;
    const isLastOptions = (options[options.length - 3] && selectedValue === options[options.length - 3].value) &&
      ((options[options.length - 2] && value === options[options.length - 2].value) ||
        (options[options.length - 1] && value === options[options.length - 1].value));

    if (isNextOption || isLastOptions) {
      setSelectedOption(value);
      setShowConfirmation(true);
      resetJumpBallClock();
    } else {
      toast.error("You Can Only Select The Next Option.");
    }
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const confirmChange = () => {
    setShowConfirmation(false);
    setSelectedValue(selectedOption);

   onChange(selectedOption);
    dispatch(sendTimerData({
      shotClockValue,
      currentIsRunning: true,
      minutes,
      seconds,
      event_id,
      event_group_id,
      quarter: selectedOption,
      event_team_a_id,
      event_team_b_id
    }))

};

const cancelChange = () => {
  setShowConfirmation(false);
};

useEffect(() => {
  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, []);

return (
  <div className={`custom-dropdown relative ${dropdownContainer}`} ref={dropdownRef}>
    <button className={`dropdown-header  ${customStyle}`} onClick={toggleDropdown}>
      {selectedValue || 'Select'}
      <i className={`arrow ${isOpen ? 'up' : 'down'}`} />
      {isOpen ? <IconCollection
        customClass='md:max-w-6 max-w-[10px] w-full md:h-6 h-[10px]'
        name="arrow-up" /> : <IconCollection
        customClass='md:max-w-6 max-w-[10px] w-full md:h-6 h-[10px]'
        name="arrow-down" />}
    </button>
    {isOpen && (
      <ul className={`dropdown-list z-[51]  ${customStyleDropdownList}`}>
        {options.map((option, index) => (
          <li
            className={` ${liCustomStyle} ${index === options.length - 1 ? 'border-none' : ''}`}
            key={option.value}
            onClick={() => handleOptionClick(option.value)}
            disabled={option.value === selectedValue} // Disable previously selected option
          >
            {option.label}
          </li>
        ))}
      </ul>
    )}
    {/* Confirmation Popup */}
    {showConfirmation && (
      <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-[60]">
        <div className="bg-white p-8 rounded-md shadow-md">
          <p className="text-lg font-bebas mb-4">Are you sure you want to change the period?</p>
          <div className="flex justify-center items-center gap-10 mt-6">
            <button className="bg-black   text-white  max-w-[80px] w-full h-8 flex justify-center items-center    font-bebas rounded" onClick={cancelChange}>NO</button>
            <button className="bg-primary text-white  max-w-[80px] w-full h-8 flex justify-center items-center   font-bebas  rounded" onClick={confirmChange}>Yes</button>
          </div>
        </div>
      </div>
    )}
  </div>
);
};

CustomDropdownControlPage.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  setSelectedValue: PropTypes.func.isRequired,
  selectedValue: PropTypes.string,
  showConfirmation: PropTypes.bool.isRequired,
  setShowConfirmation: PropTypes.func.isRequired,
  selectedOption: PropTypes.string,
  setSelectedOption: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onChangeReset: PropTypes.func,
  customStyle: PropTypes.string,
  customStyleDropdownList: PropTypes.string,
  liCustomStyle: PropTypes.string,
  defaultValue: PropTypes.string,
  dropdownContainer: PropTypes.string,
};

export default CustomDropdownControlPage;
